import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-sm border px-2 py-0.5 text-xs font-medium",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-primary-foreground",
        secondary: "border-transparent bg-secondary text-foreground",
        outline: "border-input text-foreground",
        neutral: "bg-muted border-border text-muted-foreground",
        destructive:
          "bg-destructive-subtle border-destructive-border text-destructive-text",
        success: "bg-success-subtle border-success-border text-success-text",
        warning: "bg-warning-subtle border-warning-border text-warning-text",
        info: "bg-info-subtle border-info-border text-info-text",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

export function Badge({
  className,
  variant,
  ...props
}: React.HTMLAttributes<HTMLSpanElement> & VariantProps<typeof badgeVariants>) {
  return (
    <span className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}
